module.exports = __webpack_public_path__ + "static/8c7db1fdedb0f8a1c50c7d03c574a15a15bd722a61aaac8f7bc27ca75f78892e-554535c2bdd3d5cdc25df94f5c499d40.png";